export const basicOptions = {
  maintainAspectRatio: false,
  responsive: true,
};

export let ZerolineChartOptions = {
  ...basicOptions,
  scales: {
    yAxes: [
      {
        ticks: {
          stepSize: 0.02,
          //Minimum will be -0.1, unless there is a lower value.
          suggestedMin: -0.1,
          //Maximum will be 0.1, unless there is a higher value.
          suggestedMax: 0.1,
          padding: 10,
          fontColor: "#9a9a9a",
          //Set under 0 values as positive values
          callback: function(value, index, values) {
            return value < 0 ? -value : value;
          }
        }
      }
    ],
    xAxes: [
      {
        gridLines: {
          //Hide vertical lines of grid
          display: false
        },
        ticks: {
          padding: 10,
          fontColor: "#9a9a9a",
        }
      }
    ]
  },
  hover: {
    //Mode "nearest" set hover just over the point of the dataset selected
    //Mode "index" set hover over same point in differents dataset
    mode: 'nearest',
    intersect: true,
  },
  legend: {
    onClick: function (e) {
      e.stopPropagation();
    },
    labels:{
      boxWidth: 15,
      padding: 40,
      generateLabels: function(chart) {
        let labels = Chart.defaults.global.legend.labels.generateLabels(chart);
        let awayTeamLabel = {...labels[0]};
        //Get awayTeamName to show on the labels
        awayTeamLabel.text = chart.data.datasets[0].awayTeamName;
        //Update +1 datasetIndex
        awayTeamLabel.datasetIndex = labels[0].datasetIndex + 1;

        //Add second label to labels array
        labels.push(awayTeamLabel);
        for (var key in labels) {
          //First Dataset
          if(labels[key].datasetIndex === 0){
            labels[key].fillStyle = "rgba(109, 125, 229, 0.5)"; //#6d7de5
            labels[key].strokeStyle = "#3366FF"; //rgba(51, 102, 255, 1)
          }else{
            //Second Dataset
            labels[key].fillStyle = "rgba(125, 125, 125, 0.5)"; //#7D7D7D
            labels[key].strokeStyle = "#000000"; //rgba(0, 0, 0, 1)
          }
        }
        return labels;
      }
    },
    position: "bottom",
    align: "center",
  },
  tooltips: {
    backgroundColor: "#f5f5f5",
    titleFontColor: "#333",
    bodyFontStyle: "bold",
    bodyFontColor: "#666",
    bodySpacing: 4,
    xPadding: 12,
    mode: "index",
    intersect: true,
    position: "nearest",
    callbacks: {
        title: function(tooltipItem, data) {
          let itemToShow = "";
          if(data.datasets[0].isChartPerPhases){
            let itemIndex = (data.datasets[0].firstMinuteOfThePhase - 1) + (tooltipItem[0].index + 1);
            //Get the correct item from the array tooltipItems. First min is 1, first index is 0 (thats why need tooltipItem[0].index + 1)
            itemToShow = data.datasets[0].tooltipItems.filter(item => item.min === itemIndex)[0];
          }else{
            //Just need subtract on second half items
            let firstHalfExtraTime = tooltipItem[0].index > (45 + data.datasets[0].firstHalfExtraTime - 1) ? data.datasets[0].firstHalfExtraTime : 0;
            //Get the correct item from the array tooltipItems. First min is 1, first index is 0 (thats why need (item.min - 1))
            itemToShow = data.datasets[0].tooltipItems[tooltipItem[0].index];
            //itemToShow = data.datasets[0].tooltipItems.filter(item => (item.min - 1) === (tooltipItem[0].index - firstHalfExtraTime))[0];
          }
          //Sometimes, tooltip doesn't found itemToShow (that's because database returns more items than minutes of the match)
          if(!itemToShow){
            return "";
          }
          return "    " + itemToShow.gameResult;
        },
        beforeLabel: function(tooltipItem, data) {
          let itemToShow = "";
          if(data.datasets[0].isChartPerPhases){
            let itemIndex = (data.datasets[0].firstMinuteOfThePhase - 1) + (tooltipItem.index + 1);
            //Get the correct item from the array tooltipItems
            itemToShow = data.datasets[0].tooltipItems.filter(item => item.min === itemIndex)[0];
          }else{
            //Just need subtract on second half items
            let firstHalfExtraTime = tooltipItem.index > (45 + data.datasets[0].firstHalfExtraTime - 1) ? data.datasets[0].firstHalfExtraTime : 0;
            //Get the correct item from the array tooltipItems. First min is 1, first index is 0 (thats why need (item.min - 1))
            itemToShow = data.datasets[0].tooltipItems[tooltipItem.index];
            //itemToShow = data.datasets[0].tooltipItems.filter(item => (item.min - 1) === (tooltipItem.index - firstHalfExtraTime))[0];
          }
          //Sometimes, tooltip doesn't found itemToShow (that's because database returns more items than minutes of the match)
          if(!itemToShow){
            return "";
          }
          //Remove last <br>
          let text = itemToShow.tooltip.replace(/^\s*<br\s*\/?>|<br\s*\/?>\s*$/g,'');
          //If after remove last <br> still there is one, then split because 2 lines
          return text.includes("<br>") ? text.split("<br>") : text;
        },
        label: function(tooltipItem, data) {
          let label = "";
          //Set homeTeamName when value is over 0, and awayTeamName when value is under 0
          return tooltipItem.value > 0 ? data.datasets[0].label + ": " + tooltipItem.yLabel + " xT" : data.datasets[0].awayTeamName + ": " + (-tooltipItem.value) + " xT";
        },
        //Overwrite background color to the boxes of the tooltip
        labelColor: function(tooltipItem, chart) {
          return tooltipItem.value > 0 ? { backgroundColor: "#6595D4" } : { backgroundColor: "#7D7D7D" };
        },
        labelTextColor: function(tooltipItem, chart) {
          return tooltipItem.value > 0 ? { backgroundColor: "#6595D4" } : { backgroundColor: "#7D7D7D" };
        },

    }
  },
};

export let lineChartOptions = {
  ...basicOptions,
  colors: {
    success: "#4CAF50", //rgba(76, 175, 80, 1)
    error: "#F44336", //rgba(244, 67, 54, 1)
    primaryGradient: ["rgba(244, 67, 54, 0.4)", "rgba(133, 231, 131, 0.7)"],
    driblabBlue: "#3366FF",
  },
  scales: {
    yAxes: [
      {
        ticks: {
          padding: 10,
          fontColor: "#9a9a9a",
        }
      }
    ],
    xAxes: [
      {
        ticks: {
          padding: 10,
          fontColor: "#9a9a9a",
        }
      }
    ]
  },
  hover: {
    //Mode "nearest" set hover just over the point of the dataset selected
    //Mode "index" set hover over same point in differents dataset
    mode: 'nearest',
    intersect: true,
  },
  legend: {
    labels:{
      boxWidth: 15,
      padding: 40,
      generateLabels: function(chart) {
        let labels = Chart.defaults.global.legend.labels.generateLabels(chart);
        for (var key in labels) {
          //First Dataset
          if(labels[key].datasetIndex === 0){
            labels[key].fillStyle = "#4CAF50";
          }else{
            //Second Dataset
            labels[key].fillStyle = "#F44336";
          }
        }
        return labels;
      }
    },
    position: "bottom",
    align: "center",
  },
  tooltips: {
    backgroundColor: "#f5f5f5",
    titleFontColor: "#333",
    bodyFontStyle: "bold",
    bodyFontColor: "#666",
    bodySpacing: 4,
    xPadding: 12,
    mode: "index",
    intersect: true,
    position: "nearest",
    callbacks: {
        //Set game name in tooltip as Title
        title: function(tooltipItem, data) {
          //Remove vs ALIAS from label and get just date (dd/MM)
          var title = tooltipItem[0].label.split(" ")[2] || '';
          if (title) {
              title += ' - ';
          }
          title += data.gamesName[tooltipItem[0].index];
          return title;
        },
        //Overwrite background color to the boxes of the tooltip
        labelColor: function(tooltipItem, chart) {
          if(tooltipItem.datasetIndex === 0){
            return { backgroundColor: "#4CAF50" };
          }else{
            return { backgroundColor: "#F44336" };
          }
        },
    }
  },
};

export let barChartOptions = {
  ...basicOptions,
  legend: {
    display: false,
  },
  tooltips: {
    backgroundColor: "#f5f5f5",
    titleFontColor: "#333",
    bodyFontStyle: "bold",
    bodyFontColor: "#666",
    bodySpacing: 4,
    xPadding: 12,
    mode: "index",
    intersect: true,
    position: "nearest",
  },
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
          precision: 0,
          padding: 10,
          fontColor: "#9a9a9a"
        }
      }
    ],
    xAxes: [
      {
        gridLines: {
          drawBorder: false,
          zeroLineColor: "transparent"
        },
        ticks: {
          padding: 10,
          fontColor: "#9a9a9a"
        }
      }
    ]
  }
};

export let mixedChartOptions = {
  ...basicOptions,
  legend: {
    display: false,
  },
  layout:{
    padding:{
      top: 10,
    }
  },
  tooltips: {
    backgroundColor: "#f5f5f5",
    titleFontColor: "#333",
    bodyFontStyle: "bold",
    bodyFontColor: "#666",
    bodySpacing: 4,
    xPadding: 12,
    callbacks: {
        //Set name stat in tooltip as Title
        title: function(tooltipItem, data) {
          var title = data.statsName[tooltipItem[0].index];
          return title;
        },
        label: function(tooltipItem, data) {
          if(tooltipItem.datasetIndex == 0){
            return data.tooltipText[tooltipItem.index];
          }
        },
    },
    mode: 'index',
    intersect: false
  },
  scales: {
    xAxes: [{
      gridLines: {
        lineWidth: 0,
      },
      id: "x-axis-0",
    }],
    yAxes : [{
        id: "y-axis-0",
        ticks : {
            max : 100,
            min : 0,
            fontColor: "rgba(133, 231, 131, 0)",
        },
        gridLines: {
          lineWidth: 0,
        },
    }],
  },
  "horizontalLine": [{
    "y": 90,
    "style": "rgba(115, 178, 64, 0.8)",
    "text": "90%"
  }, {
    "y": 50,
    "text": "50%",
    "style": "rgba(223, 195, 0, 0.8)"
  },
  {
    "y": 10,
    "text": "10%",
    "style": "rgba(246, 64, 48, 0.8)"
  }],
  hover: {
    //Mode "nearest" set hover just over the point of the dataset selected
    //Mode "index" set hover over same point in differents dataset
    mode: 'index',
    intersect: false
  },
};

// Options for Team Report BarCharts
export let reportBarChartOptions = {
  ...basicOptions,
  legend: {
    //position: 'bottom',
    display: true,
    labels: {
              color: 'rgb(0, 77, 127)' //'rgb(255, 99, 132)'
              //textStrokeWidth
            }
  },
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
          precision: 0,
          padding: 10,
          fontColor: "#9a9a9a"
        },
        //offset: true
      }
    ],
    xAxes: [
      {
        gridLines: {
          drawBorder: false,
          zeroLineColor: "transparent"
        },
        ticks: {
          padding: 10,
          fontColor: "#9a9a9a"
        }
      }
    ]
  }
};

// Options for Team Report Horizontal Stacked BarCharts
export let reportHorizontalStackedBarChartOptions = {
  ...basicOptions,
  legend: {
    //position: 'bottom',
    display: true,
    labels: {
              color: 'rgb(0, 77, 127)' //'rgb(255, 99, 132)'
              //textStrokeWidth
            }
  },
  scales: {
    yAxes: [
      {
        stacked: true,
        gridLines: {
          drawBorder: false,
          zeroLineColor: "transparent",
        },
        ticks: {
          beginAtZero: true,
          precision: 0,
          fontColor: "#9a9a9a"
        },
      }
    ],
    xAxes: [
      {
        stacked: true,
        gridLines: {
          drawBorder: false,
          zeroLineColor: "transparent",
        },
        ticks: {
          padding: 10,
          fontColor: "#9a9a9a",
          max : 100,
          min : 0
        }
      }
    ]
  }
};


// Options for Team Report Horizontal Stacked BarCharts
export let reportVerticalStackedBarChartOptions = {
  ...basicOptions,
  legend: {
    display: true,
    labels: {
              color: 'rgb(0, 77, 127)' //'rgb(255, 99, 132)'
            }
  },
  scales: {
    yAxes: [
      {
        stacked: true,
        gridLines: {
          drawBorder: false,
          zeroLineColor: "transparent",
        },
        ticks: {
          beginAtZero: true,
          precision: 0,
          fontColor: "#9a9a9a"
        },
      }
    ],
    xAxes: [
      {
        stacked: true,
        gridLines: {
          drawBorder: false,
          zeroLineColor: "transparent",
        },
        ticks: {
          padding: 10,
          fontColor: "#9a9a9a",
        }
      }
    ]
  }
};
